import { render, staticRenderFns } from "./EmailSettingsForm.vue?vue&type=template&id=15ea01a9&scoped=true"
import script from "./EmailSettingsForm.vue?vue&type=script&lang=ts"
export * from "./EmailSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./EmailSettingsForm.vue?vue&type=style&index=0&id=15ea01a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea01a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ea01a9')) {
      api.createRecord('15ea01a9', component.options)
    } else {
      api.reload('15ea01a9', component.options)
    }
    module.hot.accept("./EmailSettingsForm.vue?vue&type=template&id=15ea01a9&scoped=true", function () {
      api.rerender('15ea01a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/EmailSettingsForm/EmailSettingsForm.vue"
export default component.exports